// https://docs.nosto.com/techdocs/apis/frontend/js-apis/record-attribution
// Not needed at the moment; createRecommendationRequest does the job
const nostoRecordAttribution = (product_id, ref_id, attribution_type = 'vp') => {
  nostojs(api => api.recordAttribution({ 
      type: attribution_type,
      target: String(product_id), 
      ref: ref_id, 
      refType: 'api',
    }).done()
  );
};

// https://docs.nosto.com/techdocs/apis/frontend/js-apis/recommendations/sending-product-view-events#sending-product-variant-view-events
// Triggered when a product from a recommendation list gets viewed.
const nostoRecommendedProductViewEvent = (product_id, recommendation_id, is_quickview = false) => {
  nostojs(api => {
    api.createRecommendationRequest()
      .setProducts([{product_id: String(product_id)}], recommendation_id)
      .setResponseMode('JSON_ORIGINAL')
      .load({skipPageViews: is_quickview})
      .then(response => {
        console.log(`[ASTR] nostoRecommendedProductViewEvent()`, response);
      });
  });
};

// https://docs.nosto.com/techdocs/apis/frontend/js-apis/recommendations/sending-product-view-events#sending-product-variant-view-events
// Triggered when the user changes variant on the product page
const nostoRecommendedVariantViewEvent = (product_id, variant_id, is_quickview = false) => {
  nostojs(api => {
    api.createRecommendationRequest({includeTagging:true})
      .setProducts([{product_id: String(product_id), selected_sku_id: String(variant_id)}])
      .setResponseMode('JSON_ORIGINAL')
      .load({skipPageViews: is_quickview})
      .then(response => {
        console.log(`[ASTR] nostoRecommendedVariantViewEvent()`, response);
        
        if (response.recommendations.length === 0) {
          return;
        }

        const event = new CustomEvent('astr-nosto-recommendations-refresh', { 
          detail: {
            message: 'Variant has been selected - refresh Nosto recommendations',
            data: response.recommendations,
          }
        });

        document.dispatchEvent(event);
      });
  });
};

// https://docs.nosto.com/techdocs/apis/frontend/js-apis/recommendations/sending-add-to-cart-events
// Not needed at the moment since we don't have an add to cart button on the recommendation tiles
const nostoRecommendedProductAddToCartEvent = (product_id, recommendation_id) => {
  nostojs(api => {
    api.recommendedProductAddedToCart(String(product_id), recommendation_id);
  });
};

// https://docs.nosto.com/techdocs/implementing-nosto/implement-search/search#search-product-click
// Used in nostoInitGlobalEvents and quicklook/index.js
const nostoRecordSearchClickEvent = (click_location, product_id, product_url) => {
  nostojs(api => {
    api.recordSearchClick(click_location, { productId: String(product_id), url: product_url });
  });
};

// Capture the click event from the product tile for Nosto tracking
const nostoInitGlobalEvents = () => {
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-product-tile]') !== null && e.target.closest('[data-product-tile-colors]') === null && !e.target.matches('[data-quicklook-button]') && !e.target.matches('[data-quicklook-button-mobile]') && !e.target.matches('[data-product-swym-wishlist]')) {
      let click_location = '';
      
      if (e.target.closest('[data-collection-grid]') !== null) {
        click_location = 'category';
      }

      if (e.target.closest('[data-overlay-search-results]') !== null) {
        click_location = 'serp';
      }
      
      if (e.target.closest('.ns-autocomplete-product-tile') !== null) {
        click_location = 'autocomplete';
      }

      if (e.target.closest('[data-nosto-recommendations]') !== null) {
        click_location = 'recommendation';
      }
      
      if (click_location === '') {
        return;
      }

      e.preventDefault();
      
      const item = e.target;
      const tile = item.closest('[data-product-tile]');
      const product_url = tile.querySelector('.product-tile__image').href;
      const product_id = tile.dataset.productId;

      console.log('[ASTR] Product tile clicked', click_location, product_id, product_url);

      if (click_location === 'recommendation') {
        const nosto_list = e.target.closest('.nosto_element');
        const recommendation_id = nosto_list.id;
        nostoRecommendedProductViewEvent(product_id, recommendation_id, false);
      } else {
        nostoRecordSearchClickEvent(click_location, product_id, product_url);
      }
      
      window.location.href = product_url;
    }
  });
};

// https://docs.nosto.com/techdocs/apis/frontend/js-apis/recommendations/sending-add-to-cart-events
// In case we have an add to cart button directly on the product tile
// Can also be used for page views per discussion with Nosto team

export {
  nostoInitGlobalEvents,
  nostoRecordSearchClickEvent,
  nostoRecommendedProductViewEvent,
  nostoRecommendedVariantViewEvent,
  nostoRecommendedProductAddToCartEvent,
  nostoRecordAttribution,
};
